import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import GeneralButton from 'components/komparu/button/GeneralButton';
import Header from 'components/ui/general/Header';
import ProductPropertiesEdit from './ProductPropertiesEdit';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageEyeIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { fetchProductProperty } from 'store/actions/productProperties/fetchProductProperties';
import utils from 'helpers/utils';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';

class ProductPropertiesEditContainer extends React.Component {
    componentDidMount() {
        this.props.fetchProductProperty({
            propertyId: this.props.propertyId,
            productId: this.props.productId,
        });
    }

    showContent = () => {
        const { isLoading, product, productId, propertyId } = this.props;

        if (isLoading || !product) {
            const loading = translate('general.loading');

            return (
                <CardText>
                    <div>{ loading }</div>
                </CardText>
            );
        }

        // Check if the property is available.
        if (!product.hasOwnProperty(propertyId)) {
            return (
                <CardText>
                    <div>Whoops, something went wrong.</div>
                </CardText>
            );
        }

        return (
            <CardText>
                <ProductPropertiesEdit
                    currentValues={ product[propertyId] }
                    productId={ productId }
                    propertyId={ propertyId }
                />
            </CardText>
        );
    }

    render() {
        const {
            product,
            productId,
            products,
            propertyId,
            property,
            translate,
        } = this.props;

        if (utils.isEmpty(product)) {
            return null;
        }

        let productName = productId;
        let propertyName = propertyId;

        if (!utils.isEmpty(products)) {
            productName = products.title;
        }

        if (!utils.isEmpty(property)) {
            propertyName = property.name;
        }

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: productName,
                link: `/products/${ productId }/show`,
            },
            {
                label: translate('resources.properties.title'),
            },
            {
                label: propertyName,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ `${ translate('actions.edit') } ${ translate('resources.properties.title') }` } />

                    <Actions>
                        <GeneralButton
                            history={ this.props.history }
                            label={ `${ translate('actions.show') }` }
                            linkTo={ `/products/${ this.props.productId }/show` }
                            icon={ <ImageEyeIcon color={ theme.palette.primary1Color } /> }
                        />
                    </Actions>
                </Header>

                <Card>
                    { this.showContent() };
                </Card>
            </div>
        );
    }
}

ProductPropertiesEditContainer.propTypes = {
    history: PropTypes.object,
    productId: PropTypes.string.isRequired,
    product: PropTypes.object,
    products: PropTypes.object,
    propertyId: PropTypes.string.isRequired,
    property: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    fetchProductProperty: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    connect(
        (state, props) => {
            const {
                match: {
                    params: {
                        id,
                        propertyId,
                    },
                },
            } = props;

            const {
                productProperties: {
                    data,
                    loading,
                },
                products,
                properties,
            } = state;

            const product = data[id];
            let property_id;

            if (!utils.isEmpty(product)) {
                property_id = product[propertyId].property_id;
            }

            return {
                productId: id,
                propertyId: propertyId,
                product: product,
                isLoading: loading,
                products: products.data[id],
                property: properties.data[property_id],
            };
        },
        {
            fetchProductProperty: fetchProductProperty,
        },
    ),
    translate,
);

export default enhance(ProductPropertiesEditContainer);



// WEBPACK FOOTER //
// ./src/pages/products/productProperties/edit/ProductPropertiesEditContainer.js